import { useTranslation } from "react-i18next";

/**
 * Builds the messages of a MultiSelect in an analysis toolbar: the shared picker
 * copy from `common`, read through the tree's i18n (the tables render standalone
 * in the tests), with the filter's own placeholder.
 */
export function usePickerMessages() {
  const { t } = useTranslation("common");
  return (placeholder: string, emptyLabel?: string) => ({
    placeholder,
    searchPlaceholder: t("searchPlaceholder"),
    emptyLabel: emptyLabel ?? t("noOptionsFound"),
    loadingLabel: t("list.loadingOptions"),
    selectedLabel: t("list.selected"),
    clearLabel: t("clearSelection"),
    removeLabel: (label: string) => t("list.remove", { label }),
    overflowLabel: (count: number) => t("list.more", { count }),
  });
}
